import BaseHandler from "../BaseHandler";
import { GroupAvatarAdd, GroupAvatarAddResponse } from "../../proto/GroupAvatarAdd_pb";
import { editRoom, editRoomExtra, updateGroupAvatar } from "../../store/rooms/actions";
import store from "../../store";
import { addAvatars } from "../../store/avatars/actions";
import { updateUser } from "../../store/users/actions";
import { getStorage } from "../../libs/storage";
import { STORAGE_USER_ID } from "../../constants/localstorage";

export default class HandleGroupAddAvatarResponse extends BaseHandler<GroupAvatarAddResponse, GroupAvatarAdd> {
  handle() {
    const groupAddAvatarLinkResponse = this.response.toObject();

    if (groupAddAvatarLinkResponse !== undefined) {
      if (groupAddAvatarLinkResponse.avatar)
        store.dispatch(
          editRoomExtra({
            groupRoomExtra: {
              avatar: groupAddAvatarLinkResponse.avatar,
            },
            roomId: groupAddAvatarLinkResponse.roomId,
          })
        );

      if (groupAddAvatarLinkResponse.avatar)
        store.dispatch(
          addAvatars({
            roomId: groupAddAvatarLinkResponse.roomId,
            avatars: [groupAddAvatarLinkResponse.avatar],
          })
        );
    }
  }
}
